import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { SupabaseClient } from '../supabase/client';
import type { Store, UpdateStoreNewsletterCollectionInput } from '../types/store';
import { updateStoreNewsletterCollection } from '../services/store-newsletter-collection.service';

export function useUpdateStoreNewsletterCollection(
  client: SupabaseClient,
): UseMutationResult<Store, unknown, UpdateStoreNewsletterCollectionInput> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateStoreNewsletterCollectionInput) =>
      updateStoreNewsletterCollection(client, input),
    onSuccess: async (row, input) => {
      queryClient.setQueryData(['store', input.storeId], row);
      await Promise.all([
        queryClient.invalidateQueries(
          { queryKey: ['store', input.storeId] },
          { throwOnError: true },
        ),
        queryClient.invalidateQueries(
          { queryKey: ['website-editor-state', input.storeId] },
          { throwOnError: true },
        ),
        queryClient.invalidateQueries(
          { queryKey: ['website-canvas-render-data', input.storeId] },
          { throwOnError: true },
        ),
        queryClient.invalidateQueries(
          { queryKey: ['website-template-preview', input.storeId] },
          { throwOnError: true },
        ),
        queryClient.invalidateQueries(
          { queryKey: ['public-store-website', row.slug] },
          { throwOnError: true },
        ),
      ]);
    },
  });
}
